import { isProductionMode } from "./consts"

export const getCookie = (name: string): string | undefined => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts && parts.length === 2) return parts.pop()?.split(";").shift()
}

const AUTH_COOKIE_NAME = () =>
  isProductionMode() ? "prodToken" : "stagingToken"

export const getAuthCookie = (): string | undefined => {
  return getCookie(AUTH_COOKIE_NAME())
}

// The auth cookie is set by the old frontend with `domain=.babele.co` so both
// frontends can share it. To delete it we need to match that domain attribute.
// We also try no-domain and the exact hostname to cover local dev, previews,
// and any edge cases where the cookie was set without the parent domain.
export const clearAuthCookie = (): void => {
  const name = AUTH_COOKIE_NAME()
  const expire = "expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/"
  document.cookie = `${name}=; ${expire}`
  document.cookie = `${name}=; ${expire}; domain=${window.location.hostname}`
  document.cookie = `${name}=; ${expire}; domain=.babele.co`
}
